// DirectBuyIn taxonomy navigation behavior.
if (!customElements.get('taxonomy-menu')) {
  customElements.define(
    'taxonomy-menu',
    class TaxonomyMenu extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.details?.querySelector(':scope > summary');
        this.closeTimer = null;
        this.departmentButtons = [...this.querySelectorAll('[data-taxonomy-department]')];
        this.categoryButtons = [...this.querySelectorAll('[data-taxonomy-category]')];
        this.departmentButtons.forEach((button) => this.bindTab(button, () => this.activateDepartment(button)));
        this.categoryButtons.forEach((button) => this.bindTab(button, () => this.activateCategory(button)));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          window.clearTimeout(this.closeTimer);
          this.details.open = true;
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch') return;
          this.closeTimer = window.setTimeout(() => {
            this.details.open = false;
          }, 140);
        });
        this.details?.addEventListener('toggle', () => {
          this.summary?.setAttribute('aria-expanded', String(this.details.open));
        });
        document.addEventListener('click', (event) => {
          if (this.details?.open && !this.contains(event.target)) this.details.open = false;
        });
      }

      bindTab(button, activate) {
        button.addEventListener('click', activate);
        button.addEventListener('focus', activate);
        button.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') activate();
        });
      }

      activateDepartment(button) {
        this.setActive(this.departmentButtons, button);
        this.showPanel('[data-taxonomy-category-panel]', button.dataset.taxonomyTarget);
        const categoryPanel = this.panel(button.dataset.taxonomyTarget);
        const firstCategory = categoryPanel?.querySelector('[data-taxonomy-category]');
        if (firstCategory) this.activateCategory(firstCategory);
      }

      activateCategory(button) {
        const categoryPanel = button.closest('[data-taxonomy-category-panel]');
        const siblingButtons = [...(categoryPanel?.querySelectorAll('[data-taxonomy-category]') || [])];
        this.setActive(siblingButtons, button);
        this.showPanel('[data-taxonomy-subcategory-panel]', button.dataset.taxonomyTarget);
      }

      setActive(buttons, activeButton) {
        buttons.forEach((button) => {
          const active = button === activeButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
        });
      }

      showPanel(selector, id) {
        this.querySelectorAll(selector).forEach((panel) => {
          panel.hidden = panel.id !== id;
        });
      }

      panel(id) {
        return [...this.querySelectorAll('[id]')].find((element) => element.id === id);
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.details?.open) {
          this.details.open = false;
          this.summary?.focus();
          return;
        }
        const button = event.target.closest('[data-taxonomy-department], [data-taxonomy-category]');
        if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const buttons = button.hasAttribute('data-taxonomy-department')
          ? this.departmentButtons
          : [...button.closest('[data-taxonomy-category-panel]').querySelectorAll('[data-taxonomy-category]')];
        const currentIndex = buttons.indexOf(button);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % buttons.length;
        if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        event.preventDefault();
        buttons[nextIndex].focus();
      }
    }
  );
}

if (!customElements.get('taxonomy-drawer')) {
  customElements.define(
    'taxonomy-drawer',
    class TaxonomyDrawer extends HTMLElement {
      connectedCallback() {
        // Dawn treats every button inside header-drawer as a submenu close
        // control. Capture our accordion clicks first so they only toggle the
        // requested taxonomy panel and leave the outer drawer open.
        this.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest('[data-taxonomy-drawer-toggle]');
            if (!button || !this.contains(button)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            this.toggle(button);
          },
          { capture: true }
        );
      }

      toggle(button) {
        const panel = this.querySelector(`[id="${CSS.escape(button.getAttribute('aria-controls'))}"]`);
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      }
    }
  );
}
